import { Icon } from '@chakra-ui/react';

const PCParagraphIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

		<g>
			<path class="st0" d="M29.67,27.57c-0.23,0.26-0.55,0.32-0.95,0.32c-9.16-0.01-18.33,0-27.49-0.01c-0.14,0-0.28,0.01-0.41-0.01
		c-0.33-0.06-0.52-0.22-0.52-0.48c0-0.26,0.2-0.42,0.52-0.48c0.13-0.02,0.27-0.01,0.41-0.01c9.16,0,18.33,0,27.49-0.01
		c0.4,0,0.72,0.06,0.95,0.32C29.67,27.32,29.67,27.44,29.67,27.57z"/>
			<path class="st0" d="M29.67,23.92c-0.23,0.26-0.55,0.32-0.95,0.32c-9.16-0.01-18.33,0-27.49-0.01c-0.14,0-0.28,0.01-0.41-0.01
		C0.49,24.16,0.29,24,0.29,23.74c0-0.26,0.2-0.42,0.52-0.48c0.13-0.02,0.27-0.01,0.41-0.01c9.16,0,18.33,0,27.49-0.01
		c0.4,0,0.72,0.06,0.95,0.32C29.67,23.67,29.67,23.8,29.67,23.92z"/>
			<path class="st0" d="M16.58,18.77c3.59,0,7.17,0,10.76,0c0.2,0,0.4,0,0.6,0c0.88,0.02,1.42,0.21,1.4,0.51
		c-0.02,0.29-0.58,0.49-1.46,0.49c-7.55,0-15.1,0-22.64,0c-0.7,0-1.25-0.1-1.43-0.39c-0.15-0.25,0.11-0.46,0.68-0.56
		c0.33-0.06,0.74-0.05,1.11-0.05C9.26,18.77,12.92,18.77,16.58,18.77z"/>
			<path class="st0" d="M22.76,14.92c1.85,0,3.7,0,5.54,0c0.1,0,0.21,0,0.31,0c0.46,0.02,0.73,0.21,0.72,0.51
		c-0.01,0.29-0.3,0.49-0.75,0.49c-3.89,0-7.78,0-11.67,0c-0.36,0-0.64-0.1-0.74-0.39c-0.08-0.25,0.05-0.46,0.35-0.56
		c0.17-0.06,0.38-0.05,0.57-0.05C18.99,14.92,20.88,14.92,22.76,14.92z"/>
			<path class="st0" d="M22.76,10.63c1.85,0,3.7,0,5.54,0c0.1,0,0.21,0,0.31,0c0.46,0.02,0.73,0.21,0.72,0.51
		c-0.01,0.29-0.3,0.49-0.75,0.49c-3.89,0-7.78,0-11.67,0c-0.36,0-0.64-0.1-0.74-0.39c-0.08-0.25,0.05-0.46,0.35-0.56
		c0.17-0.06,0.38-0.05,0.57-0.05C18.99,10.63,20.88,10.63,22.76,10.63z"/>
			<path class="st0" d="M22.76,5.88c1.85,0,3.7,0,5.54,0c0.1,0,0.21,0,0.31,0c0.46,0.02,0.73,0.21,0.72,0.51
		c-0.01,0.29-0.3,0.49-0.75,0.49c-3.89,0-7.78,0-11.67,0c-0.36,0-0.64-0.1-0.74-0.39c-0.08-0.25,0.05-0.46,0.35-0.56
		c0.17-0.06,0.38-0.05,0.57-0.05C18.99,5.88,20.88,5.88,22.76,5.88z"/>
			<path class="st0" d="M22.76,1.95c1.85,0,3.7,0,5.54,0c0.1,0,0.21,0,0.31,0c0.46,0.02,0.73,0.21,0.72,0.51
		c-0.01,0.29-0.3,0.49-0.75,0.49c-3.89,0-7.78,0-11.67,0c-0.36,0-0.64-0.1-0.74-0.39c-0.08-0.25,0.05-0.46,0.35-0.56
		c0.17-0.06,0.38-0.05,0.57-0.05C18.99,1.95,20.88,1.95,22.76,1.95z"/>
			<path class="st0" d="M10.04,15.32c-0.46,0-0.88,0-1.32,0c0-4.08,0-8.15,0-12.24c-0.6,0-1.16,0-1.76,0c0,4.08,0,8.15,0,12.24
		c-0.45,0-0.87,0-1.32,0c0-2.07,0-4.13,0-6.24c-0.28,0-0.53,0-0.78,0c-0.68,0-1.36,0.03-2.01-0.22C1.33,8.29,0.33,6.76,0.45,5.17
		C0.57,3.5,1.79,2.11,3.41,1.8c0.22-0.04,0.44-0.06,0.66-0.06c2.57,0,5.15,0,7.72,0c0.06,0,0.12,0,0.2,0c0,0.44,0,0.86,0,1.31
		c-0.64,0-1.28,0-1.95,0C10.04,7.15,10.04,11.22,10.04,15.32z M5.63,3.06c-0.37,0-0.7-0.01-1.04,0c-0.37,0.01-0.75,0-1.1,0.08
		C2.38,3.42,1.65,4.5,1.77,5.65c0.11,1.11,1.02,2.02,2.15,2.09c0.57,0.04,1.14,0.01,1.71,0.01C5.63,6.18,5.63,4.63,5.63,3.06z"/>
		</g>

	</Icon>
);

export default PCParagraphIcon;
